import { Box } from "@chakra-ui/react";
import { motion } from "framer-motion";

const CustomMotionDiv = motion(Box);

export default function MotionBox(props) {
  return <CustomMotionDiv {...props} />;
}
